//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/NXObject.js";
let d=[[],[[[],"Enter",{},0,0],[[],"Exit",{},0,0],[["uid"],"EstablishProject",{},1,0],[[],"GetProject",{R_:{project:"AME.Project"}},0,0],[[],"GetGlobalSelectionBuilder",{R_:{selectionBuilder:"AME.GlobalSelectionBuilder"}},0,0],[[],"SaveProject",{},0,0],[["workSet"],"CreateCollaborativeDesign",{R_:{project:"AME.Project"}},1,0],[["workSet","cdID"],"CreateCollaborativeDesign1",{R_:{project:"AME.Project"}},2,0],[["workSet"],"EstablishNewProject",{R_:{project:"AME.Project"}},1,0],[["workPart","name","desc","id"],"SetPartAttributes",{},4,0]],[]];
SPLM.AME.ApplicationBuilder = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.ApplicationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;